import React from "react";
import { message } from "antd";
import { Navigate } from 'react-router-dom'
import SignUp from "../../../components/signup";
export default function index() {

  const handleSignupSuccess = () => {
      <Navigate to="/auth/login"/>
        message.success("Sign Up successfully")
  };

  return (
    <div>
      <SignUp handleSignupSuccess={handleSignupSuccess} />
    </div>
  );
}
